module.exports = __webpack_public_path__ + "img/logo@3x.54a98a01.png";